import { Component, OnInit }   from '@angular/core';
import { Router }              from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ComponentBase } from '../base/component-base';
import { UtilService } from '../service/util.service';
import { ISelectionBox } from '../model/ISelectionBox';
import { ApplicantService } from '../service/applicant.service';
import { BehaviorModelChangeService } from '../service/behavior-model-change.service.service';
import { CookiesLocalService } from '../service/cookies-local.service';

@Component({
  selector: 'app-personal-contact',
  templateUrl: './personal-contact.component.html',
  styleUrls: ['./personal-contact.component.css']
})
export class PersonalContactComponent extends ComponentBase implements OnInit {

  title = 'Please tell us about yourself.';
  applicantContantInfo: FormGroup;
  countries: ISelectionBox[];
  regions: ISelectionBox[];
  constructor(private fb: FormBuilder, private router: Router,
              private utilService: UtilService,
              applicantService: ApplicantService, cookieLocal: CookiesLocalService,
              behaviorModelChangeService: BehaviorModelChangeService) {

          super(applicantService, cookieLocal, behaviorModelChangeService);

  }



  ngOnInit() {

    this.applicantContantInfo = this.getPersonalContact();
    this.getLoadData();

  }


  getPersonalContact(): FormGroup {

    const data = this.applicantData;
    const cId = data.CountryId ? data.CountryId.trim() : '';

    if (data) {

      return  this.fb.group({
        CountryId: [cId, Validators.required],
        City: [data.City, Validators.required],
        Email: [data.Email, Validators.required],
        PrimaryNumber: [data.PrimaryNumber, Validators.required],
        OtherNumber: [data.OtherNumber],
        ResidentialAddress1: [data.ResidentialAddress1, Validators.required],
        AddressLine1: [data.AddressLine1, Validators.required],
        RegionId: [data.RegionId],
        FaxNumber: [data.FaxNumber],
        GhanaPostCode: [data.GhanaPostCode],
        HomeTown: [data.HomeTown, Validators.required],
      });
    }

    return  this.fb.group({
            CountryId: ['', Validators.required],
            City: ['', Validators.required],
            Email: ['', Validators.required],
            PrimaryNumber: ['', Validators.required],
            OtherNumber: [''],
            ResidentialAddress1: ['', Validators.required],
            AddressLine1: ['', Validators.required],
            RegionId: [''],
            FaxNumber: [''],
            GhanaPostCode: [''],
            HomeTown: ['', Validators.required],
          });

    }

  save(form: any): boolean {
    if (!form.valid) {
      return false;
    }
    return true;
  }

  goToNext(form: any) {
    if (this.save(form)) {

      const data = this.applicantContantInfo.value;

      const model = this.cookieLocal.getApplicantData();

      model.CountryId = data.CountryId;
      model.City = data.City;
      model.Email = data.Email;
      model.PrimaryNumber = data.PrimaryNumber;
      model.OtherNumber = data.OtherNumber;
      model.ResidentialAddress1 = data.ResidentialAddress1;
      model.AddressLine1 = data.AddressLine1;
      model.RegionId = data.RegionId;
      model.FaxNumber = data.FaxNumber;
      model.GhanaPostCode = data.GhanaPostCode;
      model.HomeTown = data.HomeTown;
      this.applicantService.savePersonalData(model).subscribe(() => {
        this.cookieLocal.getRefreshedApplicantData(model);

      }, error => {
        console.log(error);
      });


      // this.formDataService.setContactInfo(this.applicantContantInfo.value);
      this.router.navigate(['/applicant/info/personal/guardian']);
    }
  }

  goToPrevious(form: any) {
    this.router.navigate(['/applicant/info/personal/basic']);
  }


  getLoadData() {

    this.utilService.getCountries().subscribe(data => { this.countries = data; });
    this.utilService.getRegions().subscribe(data => { this.regions = data; });
  }



}
